<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Presupuestos por ubicación</h1>
                <div class="caption">
                    Muestra los presupuestos realizados por ubicación geográfica considerando los valores ingresados en la
                    dirección de obra.
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuDesde"
                                :return-value.sync="menuDesde"
                                ref="menuDesde"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuDesde.save(d.desde)"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuHasta"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly
                                    ref="menuHasta"
                            ></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuHasta.save(d.hasta)"
                            ></v-date-picker>
                        </v-menu>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-layout row wrap>
            <v-flex>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
                <GmapMap
                        :center="mapCoords"
                        :zoom="mapZoom"
                        map-type-id="terrain"
                        style="width: 100%; height: 500px"
                        ref="map"
                >
                    <gmap-cluster :options="clusterOptions">
                        <GmapMarker v-for="(m,$index) in markers" :position="m.pos" :clickable="true" :key="$index" @click="toggleInfoWindow(m,$index)"/>
                    </gmap-cluster>
                    <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                        Presupuesto:
                        <router-link exact :to="'/presupuesto/' + infoContent.presupuesto_id">{{ infoContent.presupuesto_id }}</router-link>
                    </gmap-info-window>
                </GmapMap>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import monedaSelect from '../../components/MonedaSelect.vue'
    import moment from 'moment'
    import Vue from 'vue'
    import * as VueGoogleMaps from 'vue2-google-maps'
    import {gmapApi} from 'vue2-google-maps'
    import GmapCluster from 'vue2-google-maps/dist/components/cluster'

    const googleApiKey = 'AIzaSyDDUPZqkYwch0pYHORSPyW2WGy3M0rp_gE';
    Vue.use(VueGoogleMaps, {
        load: {
            key: googleApiKey,
            libraries: 'places', // This is required if you use the Autocomplete plugin
            language: 'es',
            sensor: false
        }
    });
    Vue.component('GmapCluster', GmapCluster);
    export default {
        components: {monedaSelect},
        data() {
            return {
                lateral: false,
                loading: false,
                loadingMapa: false,
                menuDesde: false,
                menuHasta: false,
                mapZoom: 5,
                d: {
                    desde: moment().subtract(1, 'month').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD'),
                },
                mapCoords: {},
                markers: [],
                infoWindowPos: null,
                infoWinOpen: false,
                infoContent: {},
                currentMidx: -1,
                infoOptions: {
                    pixelOffset: {
                        width: 0,
                        height: -35
                    }
                },
                clusterOptions:{
                    gridSize: 10,
                    maxZoom: 10,
                }
            }
        },
        mounted() {
            this.mapInit();
            this.mostrar();
        },
        methods: {
            toggleInfoWindow(marker, idx) {
                this.infoWindowPos = marker.pos;
                this.infoContent = marker.info;
                if (this.currentMidx === idx) {
                    this.infoWinOpen = !this.infoWinOpen;
                } else {
                    this.infoWinOpen = true;
                    this.currentMidx = idx;
                }
            },
            mostrar() {
                this.loading = true;
                this.$http.post('indicadores/oper-ubicacion', this.d)
                    .then(r => {
                        r.data.forEach(p => {
                            this.markers.push({
                                pos: {
                                    lat: parseFloat(p.lat),
                                    lng: parseFloat(p.lng),
                                },
                                info: {
                                    presupuesto_id: p.id
                                }
                            })
                        });
                        this.loading = false;
                        this.lateral = false;
                    }, r => {
                        alert(r);
                        this.loading = false;
                    });
            },
            mapInit() {
                this.loadingMapa = true;
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(position => {
                        this.mapCoords = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        this.loadingMapa = false;
                    }, err => {
                        this.loadingMapa = false;
                    });
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/oper-ubicacion.vue